{
  "melodicPattern": {
    "configuration": {
      "color": "Color",
      "confirmation": {
        "cancel": "Keep",
        "delete": "Delete",
        "title": "Are you sure?"
      },
      "description": "Description",
      "descriptionPlaceholder": "Describe the melodic pattern... (max. 280 characters)",
      "disclaimer": "By default, the color of a pattern\nis determined by the voice\nthe pattern first occurs in.",
      "label": "Label",
      "length": "Length",
      "occurrences": "Occurrences (unique)",
      "title": "Melodic\nPattern",
      "lock": "Pin the pattern in the graph",
      "delete": "Delete this pattern",
      "deleteConfirm": "Delete pattern {{label}} with its suggestions?",
      "deleteSuggested": "Suggested patterns disappear when their operator is hidden or their pattern is deleted."
    },
    "tooltip": {
      "disclaimer": "This pattern appears larger than it is to ensure its readability. Its size relative to other patterns is not correctly depicted."
    }
  },
  "melodyAnalysis": "Melody Analysis",
  "melodyGraph": {
    "commonOccurrencesEdge_one": "{{ count }} common occurrence",
    "commonOccurrencesEdge_other": "{{ count }} common occurrences",
    "empty": "No patterns yet. Select the first and the last note of a pattern in the sheet: the pattern, its related patterns and the operators connecting them appear here.",
    "controls": {
      "fit": "Fit the graph into view",
      "unlockAll": "Unpin all patterns",
      "focus": "Focus on the selected pattern",
      "entries": "Show every entry as a node of its own"
    }
  },
  "musicSheets": {
    "title": "{{ title }} (by {{ composer }})"
  },
  "onBoarding": {
    "step1": {
      "description": "The selected music sheet is rendered in a paper-like fashion, page by page. To perform melody analysis, you can highlight a melodic pattern by selecting its first and list note through a click.",
      "title": "Music Sheet"
    },
    "step2": {
      "description": "You can navigate through the pages of a music sheet by clicking the corresponding buttons. You can also use the arrow keys on your keyboard to navigate through the pages.",
      "title": "Music Sheet Navigation"
    },
    "step3": {
      "description": "The melody timeline gives an overview of the complete music sheet. Vertical lines indicate the page breaks, hovering to the left and the right of these vertical lines automatically switches to the corresponding page. Melodic patterns highlighted in the music sheet appear on the corresponding voice in this timeline.",
      "title": "Melody Timeline"
    },
    "step4": {
      "description": "The suggestions list eight melodic operators that can be used to generate other melodic patterns based on a melodic pattern that you highlight in the music sheet. By default, the prototype only shows melodic patterns generated through transposition. You can enable other operators by clicking on the corresponding image or hover over the corresponding image to preview the respective melodic patterns.",
      "title": "Suggestions"
    },
    "step5": {
      "description": "The melody graph shows all highlighted melodic patterns as nodes. If a melodic pattern has been highlighted through the suggestions, it will be connected to another melodic pattern through the corresponding melodic operator.",
      "title": "Melody Graph"
    },
    "step6": {
      "description": "The melodic pattern configuration allows you to change the label, the description, and the color of a melodic pattern. You can also delete a melodic pattern by clicking on the trash can icon.",
      "title": "Melodic Pattern Configuration"
    },
    "tooltip": {
      "back": "Back",
      "close": "Close",
      "next": "Next",
      "skip": "Skip",
      "progress": "{{current}} of {{total}}"
    },
    "discovery": {
      "title": "Discovered patterns",
      "description": "MelodyVis analyses every piece automatically: themes, countersubjects, imitations, sequences and motifs with all their entries. Show a family in the sheet, listen to it, or select it to see how it moves through the voices, how it is transposed or changed, and on which notes it starts."
    }
  },
  "settings": {
    "colorByVoice": "Color patterns by voice",
    "colorVoices": "Color voices in music sheet"
  },
  "suggestions": {
    "accept": "Accept",
    "decline": "Discard",
    "generate": "Generate",
    "operators": {
      "all": {
        "title": "All"
      },
      "augmentation": {
        "description": "Doubles length of all notes",
        "title": "Augmentation"
      },
      "deviation": {
        "description": "Permits up to <0>{{ deviationPercentage }} %</0> of all notes to deviate from pattern",
        "disclaimer": "A smaller percentage causes the operator to allow for less deviation, while a larger percentage causes the opposite.",
        "title": "Deviation"
      },
      "diminution": {
        "description": "Halves length of all notes",
        "title": "Diminution"
      },
      "mirror_x": {
        "description": "Mirrors pitches on x-axis through first pitch",
        "title": "Mirror on x-axis"
      },
      "mirror_y": {
        "description": "Mirrors notes on y-axis of middle note(s)",
        "title": "Mirror on y-axis"
      },
      "mirror_xy": {
        "title": "Mirror on both axes",
        "description": "Inversion and retrograde combined (retrograde inversion)"
      },
      "reduction_to_pitch": {
        "description": "Only considers pitches of pattern",
        "title": "Reduction to pitch"
      },
      "reduction_to_rhythm": {
        "description": "Only considers rhythm of pattern",
        "title": "Reduction to rhythm"
      },
      "transposition": {
        "description": "Transposes pattern by fixed but arbitrary interval",
        "title": "Transposition"
      }
    },
    "title": "Suggestions",
    "useAsDefault": "Use as default",
    "useAsDefaultTooltip": "This visibility setting for related melodic patterns will be used as default for new melodic patterns.",
    "deviationThreshold": "Deviation threshold: {{percentage}} %",
    "tonal": "Tonal variants",
    "tonalTooltip": "On: transpositions, inversions, retrogrades and deviations may keep the scale steps instead of the exact intervals, e.g. the tonal answer of a fugue. Off: only exact intervals in semitones. Applies to the next search.",
    "hint": "Select a pattern in the sheet or a discovered family to see its variants.",
    "family": {
      "summary": "{{entries}}: {{self}} as written (first entry, exact repetitions), {{related}} related by the operators below.",
      "hidden": "This family is not shown in the sheet.",
      "show": "Show in the sheet",
      "all": "Shows or hides the highlights of all related entries; the first entry and exact repetitions stay.",
      "toggle_one": "Show or hide the highlight of the {{count}} entry related this way",
      "toggle_other": "Show or hide the highlights of the {{count}} entries related this way",
      "none": "No entry of {{label}} is related to its first entry this way.",
      "notSearched": "The automatic discovery does not look for this relation. Select the pattern in the sheet to search for it.",
      "deviation": "Variants: up to 20 % of the notes differ",
      "searchHint": "To search with every operator, select notes in the sheet."
    }
  },
  "discovery": {
    "title": "Discovered patterns",
    "summary_one": "{{count}} pattern family explains {{share}} % of the notes",
    "summary_other": "{{count}} pattern families explain {{share}} % of the notes",
    "accompanies": "sounds against {{label}}",
    "roles": {
      "theme": "Theme",
      "countersubject": "Countersubject",
      "imitation": "Imitation (canon)",
      "sequence": "Sequence",
      "motif": "Motif"
    },
    "show": "Show in the sheet",
    "hide": "Hide from the sheet",
    "showAll": "Show all",
    "hideAll": "Hide all",
    "play": "Play the first entry",
    "stop": "Stop",
    "none": "No repeated patterns found in this piece.",
    "failed": "The automatic analysis failed: {{error}}",
    "computing": "Analysing the piece…",
    "patternDescription_one": "{{role}}, {{count}} entry in bars {{bars}}, found automatically.",
    "patternDescription_other": "{{role}}, {{count}} entries in bars {{bars}}, found automatically.",
    "notes_one": "{{count}} note",
    "notes_other": "{{count}} notes",
    "yours_one": "your pattern {{labels}}",
    "yours_other": "your patterns {{labels}}",
    "yoursTooltip": "Entries of this family overlap patterns you selected.",
    "next": "Not yet in your analysis: {{labels}}",
    "rename": "Rename",
    "renameField": "Name of {{label}}",
    "renamePlaceholder": "Leave empty for the starting name",
    "figures": {
      "head": "Head of {{source}}",
      "tail": "Tail of {{source}}",
      "part": "Motif from {{source}}",
      "inverted": "{{name}}, inverted",
      "repetition": "Repeated notes (repetitio)",
      "chromatic_up": "Rising chromatic line (passus duriusculus)",
      "chromatic_down": "Falling chromatic line (passus duriusculus)",
      "scale_up": "Rising stepwise line",
      "scale_down": "Falling stepwise line",
      "tirata_up": "Rising run (tirata)",
      "tirata_down": "Falling run (tirata)",
      "arpeggio_up": "Rising broken chord",
      "arpeggio_down": "Falling broken chord",
      "sigh": "Sigh (suspiratio)",
      "sighs": "Chain of sighs",
      "neighbour_up": "Upper neighbour figure",
      "neighbour_down": "Lower neighbour figure",
      "turn": "Turn (circulatio)",
      "leap_up": "Leap up a {{interval}}",
      "leap_down": "Leap down a {{interval}}",
      "exclamatio": "{{name}} (exclamatio)",
      "contour_rising": "Rising motif",
      "contour_falling": "Falling motif",
      "contour_arch": "Arch motif",
      "contour_valley": "Valley motif",
      "contour_level": "Circling motif",
      "sequence_up": "Rising sequence by {{interval}}",
      "sequence_down": "Falling sequence by {{interval}}",
      "rhythm_dotted": "{{name}}, dotted",
      "rhythm_corta": "{{name}}, figura corta",
      "fromHead": "Built on the head of {{source}}"
    },
    "leapIntervals": {
      "fourth": "fourth",
      "tritone": "tritone",
      "fifth": "fifth",
      "sixth": "sixth",
      "seventh": "seventh",
      "octave": "octave"
    },
    "sequenceIntervals": {
      "second": "seconds",
      "third": "thirds",
      "fourth": "fourths",
      "fifth": "fifths",
      "large": "large steps"
    }
  },
  "import": {
    "title": "Import sheet music",
    "submit": "Import",
    "file": "MusicXML file",
    "drop": "Click or drop a MusicXML file here",
    "hint": ".musicxml, .xml or compressed .mxl, up to 10 MB (e.g. exported from MuseScore)",
    "titleLabel": "Title",
    "composer": "Composer",
    "fromFile": "Leave empty to take it from the file.",
    "button": "Import"
  },
  "tabs": {
    "operators": "Operators & graph",
    "transitions": "Transitions of the pattern"
  },
  "transitions": {
    "hint": "Click a found pattern in the sheet or the timeline, or select your own (first and last note of a voice), to see how it moves through the piece.",
    "loading": "Finding the entries of the pattern…"
  },
  "language": "Language",
  "analysis": {
    "menu": "Analysis",
    "export": "Export analysis (.json)",
    "import": "Import analysis (.json)",
    "otherPiece": "This analysis belongs to \"{{title}}\". Open that piece first.",
    "imported_one": "{{count}} pattern imported.",
    "imported_other": "{{count}} patterns imported.",
    "invalid": "The analysis could not be imported: {{reason}}"
  },
  "family": {
    "section": "Pattern {{label}}",
    "summary": "{{entries}} in {{voices}}, bars {{first}}–{{last}}: {{same}} same, {{transposed}} transposed, {{changed}} changed.",
    "entries_one": "{{count}} entry",
    "entries_other": "{{count}} entries",
    "voices_one": "{{count}} voice",
    "voices_other": "{{count}} voices",
    "sequences_one": "{{count}} sequence (consecutive transposed entries).",
    "sequences_other": "{{count}} sequences (consecutive transposed entries).",
    "imitations_one": "{{count}} imitation (entries overlapping in time).",
    "imitations_other": "{{count}} imitations (entries overlapping in time).",
    "strip": "Entries of pattern {{label}} per voice over time",
    "voice": "Voice {{voice}}",
    "voiceShort": "{{voice}}",
    "classes": {
      "same": "Same pitches (first entry, exact or octave copy)",
      "transposed": "Transposed (real or tonal)",
      "changed": "Changed (variant, inversion, retrograde, rhythm)"
    },
    "byVoice": "Entries per voice",
    "bySemitones": "Pitch level vs. first entry (semitones)",
    "byStart": "Starting note (key areas)",
    "table": "Entries of pattern {{label}}",
    "columns": {
      "voice": "Voice",
      "bars": "Bars",
      "start": "Starts on",
      "relation": "Relation",
      "play": "Play"
    },
    "playEntry": "Play entry {{index}}",
    "where": "Voice {{voice}}, bar {{bars}}, starting on {{pitch}}",
    "rest": "a rest",
    "semitones": "{{shift}} semitones",
    "relations": {
      "prototype": "first entry",
      "exact": "exact repetition",
      "real": "real transposition",
      "tonal": "tonal transposition",
      "variant_one": "variant with {{count}} changed note",
      "variant_other": "variant with {{count}} changed notes",
      "inversion": "inversion",
      "retrograde": "retrograde",
      "augmentation": "augmentation",
      "diminution": "diminution"
    },
    "glyphs": {
      "prototype": "1st",
      "tonal": "t",
      "inversion": "Inv",
      "retrograde": "Ret"
    }
  },
  "views": {
    "sheet": "The sheet",
    "timeline": "The timeline",
    "discovery": "The discovered patterns",
    "operators": "The operators and the graph",
    "transitions": "The transitions"
  },
  "errorBoundary": {
    "title": "{{name}} could not be shown",
    "retry": "Try again"
  },
  "timeline": {
    "page": "Page {{page}}",
    "playHint": "Double-click plays this entry."
  },
  "toolbar": {
    "tour": "Start the tour",
    "exportPDF": "Export the sheet with its patterns as PDF",
    "deleteAll": "Delete all patterns",
    "deleteAllConfirm": "Delete all patterns of this piece?",
    "delete": "Delete",
    "cancel": "Cancel",
    "settings": "Display settings"
  },
  "musicSheetError": {
    "title": "This piece could not be opened",
    "retry": "Try again"
  },
  "musicSheetSelection": {
    "label": "Piece of music"
  },
  "audio": {
    "credit": "Piano: Salamander Grand Piano by Alexander Holm,",
    "failed": "The entry cannot be played: {{reason}}"
  },
  "piece": {
    "player": "Playback of the piece",
    "play": "Play the piece",
    "playFromPage": "Play from this page",
    "pause": "Pause",
    "resume": "Continue",
    "stop": "Stop the piece",
    "tempo": "Tempo (quarter notes per minute)",
    "bar": "Bar {{bar}}",
    "failed": "The piece cannot be played: {{reason}}"
  },
  "pageMode": {
    "group": "Pages of the sheet",
    "a4": "A4",
    "a4Hint": "Printed A4 pages: the music keeps its line and page breaks, zooming only enlarges the paper",
    "fit": "Fit",
    "fitHint": "Pages that fill the view: zooming changes the bars per line, the sheet never scrolls sideways"
  },
  "sheetZoom": {
    "group": "Zoom of the sheet",
    "zoomIn": "Zoom in (+, Ctrl + mouse wheel)",
    "zoomOut": "Zoom out (-, Ctrl + mouse wheel)",
    "original": "Original size (0)"
  }
}
